"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const createReducer = () => (state, action) => {
    if (action.type === 'start') {
        return {
            loading: true,
            result: null,
            error: null,
            success: false,
        };
    }
    if (action.type === 'succeed') {
        return {
            loading: false,
            result: action.payload,
            error: null,
            success: true,
        };
    }
    if (action.type === 'fail') {
        return {
            loading: false,
            result: null,
            error: action.payload,
            success: false,
        };
    }
    return state;
};
exports.default = createReducer;
//# sourceMappingURL=reducer.js.map